import React from "react";
import Slider, { SliderSlide } from "components/Slider";
import CruiseCardResult, {
  CruiseCardResultProps
} from "components/FindYourCruise/Components/CruiseCardResult";
import { useInfiniteHits } from "react-instantsearch";
import { AlgoliaCruiseHit } from "types/algolia";
import { SliderProps } from "@silversea-ssc/ui-components-react";
import type { SendEventForHits } from "instantsearch.js/es/lib/utils";
import { SearchResults } from "algoliasearch-helper";

export type CruisesSliderHitsProps = SliderProps & {
  showDestination?: boolean;
  promosContent: CruiseCardResultProps["promosBadgeContent"];
  shipsContent: CruiseCardResultProps["shipsContent"];
  virtual?: boolean;
};

const CruisesSliderHits: React.FC<CruisesSliderHitsProps> = (props) => {
  const { items, sendEvent, results } = useInfiniteHits<AlgoliaCruiseHit>();
  if (items.length == 0) return null;

  return (
    <CruisesSliderResultsRenderer
      {...props}
      items={items}
      sendEvent={sendEvent}
      refinements={results?.getRefinements()}
      filters={results?._state.filters}
    />
  );
};

type CruisesSliderResultsRendererProps = CruisesSliderHitsProps & {
  items: AlgoliaCruiseHit[];
  sendEvent: SendEventForHits;
  refinements: SearchResults.Refinement[] | undefined;
  filters: string | undefined;
};

export const CruisesSliderResultsRenderer: React.FC<
  CruisesSliderResultsRendererProps
> = ({
  showDestination = true,
  promosContent,
  shipsContent,
  variantColor,
  refinements,
  filters,
  items,
  sendEvent,
  ...props
}) => {
  return (
    <Slider {...props}>
      {items.map((hit) => (
        <SliderSlide key={hit.objectID}>
          <CruiseCardResult
            hit={hit}
            refinements={refinements}
            filters={filters}
            showDestination={showDestination}
            promosBadgeContent={promosContent}
            shipsContent={shipsContent}
            backgroundColor={variantColor == "white" ? "white" : "neutral01"}
            algoliaSendEvent={sendEvent}
          />
        </SliderSlide>
      ))}
    </Slider>
  );
};

export default CruisesSliderHits;
